import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, isEmpty } from "lodash";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import AddTemperature from "../../Profiles/AddTemperature";

import { getAttributeValue } from "../../../utils/profile";
import { isOverThreshold } from "../../../utils/temperature";

import {
  FAHRENHEIT_THRESHOLD,
  CELSIUS_THRESHOLD,
} from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  temperatureValue: {
    fontSize: "1.428em",
    marginTop: "6px",
  },
  verificationContainer: {
    //backgroundColor: colors.lightGrey,
    padding: "10px 8px",
    marginTop: "-5px",
    //height: "100%",
  },
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const WalkInOutTemperature = (props) => {
  const {
    classes,
    profile,
    language,
    onSubmitTemperature,
    temperature,
  } = props;

  const [openEdit, setOpenEdit] = React.useState(false);

  let tempStatusIcon;
  if (temperature) {
    let threshold =
      getAttributeValue(get(temperature, ["measureTemperatureEvent"]), 88) ===
      19
        ? FAHRENHEIT_THRESHOLD
        : CELSIUS_THRESHOLD;
    let value = getAttributeValue(
      get(temperature, ["measureTemperatureEvent"]),
      187
    );
    tempStatusIcon = isOverThreshold(value, threshold)
      ? images.verificationIconWarning
      : images.greenCheckmarkWhite;
  }

  return (
    <Box className={classes.verificationContainer}>
      <Box style={{ display: "flex" }}>
        <img
          src={images.temperatureIcon}
          style={{ marginRight: "10px" }}
          alt="temperature"
          height="24px"
        />
        {isEmpty(temperature) && (
          <AddTemperature
            profile={profile}
            language={language}
            onSubmit={onSubmitTemperature}
          />
        )}
      </Box>
      {!isEmpty(temperature) && (
        <Grid container style={{ marginTop: "6px" }}>
          {tempStatusIcon && (
            <Grid item>
              <img
                src={tempStatusIcon}
                alt="status"
                style={{ display: "inline-block", marginRight: "5px" }}
                height="17px"
              />
            </Grid>
          )}
          <Grid item className={classes.link} onClick={() => setOpenEdit(true)}>
            {`${getAttributeValue(
              get(temperature, ["measureTemperatureEvent"]),
              187
            )} ${
              getAttributeValue(
                get(temperature, ["measureTemperatureEvent"]),
                88
              ) === 19
                ? "°F"
                : "°C"
            }`}
          </Grid>
        </Grid>
      )}
      {openEdit && (
        <AddTemperature
          profile={profile}
          language={language}
          onSubmit={onSubmitTemperature}
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          formValues={{
            187: getAttributeValue(
              get(temperature, ["measureTemperatureEvent"]),
              187
            ),
            188: getAttributeValue(
              get(temperature, ["measureTemperatureEvent"]),
              188
            ),
            88: getAttributeValue(
              get(temperature, ["measureTemperatureEvent"]),
              88
            ),
          }}
        />
      )}
    </Box>
  );
};

export default withStyles(styles)(WalkInOutTemperature);
